export default "__VITE_ASSET__BSby6AZH__"